import { render } from "./courseCard.vue?vue&type=template&id=6cf5a857"
import script from "./courseCard.vue?vue&type=script&lang=js"
export * from "./courseCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__